import { Prop, Component, Watch, Vue } from "vue-property-decorator";
import { Action, Getter, State, Mutation } from "vuex-class";

@Component({
  components: {}
})
export default class BasePage extends Vue {
  // Getters
  @Getter getIsUnderMobile: any;
  @Getter getIsXLScreen: any;

  // Mutations
  @Mutation IS_UNDER_MOBILE: any;
  @Mutation IS_XL_SCREEN: any;

  mounted() {
    let mobileMediaQuery = window.matchMedia("(max-width: 639px)");
    this._queryMobile(mobileMediaQuery);
    mobileMediaQuery.addListener(this._queryMobile);

    let xlMediaQuery = window.matchMedia("(min-width: 1520px)");
    this._queryXLScreen(xlMediaQuery);
    xlMediaQuery.addListener(this._queryXLScreen);
  }

  _queryMobile(mediaquery) {
    if (mediaquery.matches) {
      this.IS_UNDER_MOBILE(true);
    } else {
      this.IS_UNDER_MOBILE(false);
    }
  }

  _queryXLScreen(mediaquery) {
    if (mediaquery.matches) {
      this.IS_XL_SCREEN(true);
    } else {
      this.IS_XL_SCREEN(false);
    }
  }
}
